import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/home",
      name: "home",
      component: () => import("@/module/home")
    },
    {
      path: "*",
      redirect: "/home"
    },
    {
      path: "/aboutUs",
      name: "aboutUs",
      component: () => import("@/module/aboutUs")
    },
    {
      path: "/service",
      name: "service",
      component: () => import("@/module/service")
    },
    {
      path: "/news",
      name: "news",
      component: () => import("@/module/news")
    },
    {
      path: "/newsDetail",
      name: "newsDetail",
      component: () => import("@/module/newsDetail")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js